<style lang="css">
@import '../css/bootstrap.css';
@import '../css/bootstrap-vue.css';
@import '../css/admin-table.css';
</style>
<style lang="scss" scoped>
@import '../css/admin.scss';
</style>
<template>
  <div class="admin-page">
    <admin-header :tit="this.title"></admin-header>
    <admin-side></admin-side>
    <section class="admin-template">
      <h2 class="sub-tit">관리자 관리</h2>
      <div class="contents">
        <b-container fluid>
          <!-- User Interface controls -->
            <b-row>
             <b-col class="my-1 text-left type-box">
               <b-form-group
                label="권한Type"
                label-for="form-select"
                label-cols-sm="3"
                label-align-sm="left"
                label-size="sm"
                class="mb-0 "
              >
               <b-form-select size="sm" class="item-select" id="form-select" v-model="typeSelected" :options="itemOptions"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col class="my-1 filter-box">
              <b-form-group
                label="Filter"
                label-for="filter-input"
                label-cols-sm="1"
                label-align-sm="left"
                label-size="sm"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    type="search"
                    placeholder="관리자 id를 입력해주세요."
                    v-model="searchText"
                  ></b-form-input>
                  <b-button size="sm" @click="itemFilter()" class="search-btn">검색</b-button>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Main table element -->
          <b-table
            id="table-admin-user-items"
            :items="items"
            :fields="fields"
            stacked="md"
            show-empty
            small
          >
            <template #cell(idMembers)="row">
              {{ row.value }}
            </template>
            <template #cell(idManager)="row">
              {{ row.value }}
            </template>
            <template #cell(menuAuth)="row">
              <!--{{ row.value }}-->
              <span v-if="row.value === 'SUPER_ADMIN'">어반관리자</span>
              <span v-else>일반관리자</span>
            </template>
            <template #cell(nmManager)="row">
              {{ row.value }}
            </template>
            <template #cell(telManager)="row">
              {{ row.value }}
            </template>
            <template #cell(useManager)="row">
              {{ row.value }}
            </template>
            <template #cell(actions)="row">
              <!-- <input type="text" class="default-input" :value="row.index" oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '')"> -->
              <b-button size="sm" @click="modifyItem(row.item, row.index)" class="save-btn mr-1">수정</b-button>
              <b-button size="sm" @click="deleteItem(row.item, row.index)" class="deleat-btn">삭제</b-button>
            </template>
            <template #row-details="row">
              <b-card>
                <ul>
                  <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                </ul>
              </b-card>
            </template>
          </b-table>
           <b-row>
            <b-col lg="12" class="my-1 text-right">
              <b-button variant="primary" class="new-item-btn" @click="newModal()">신규</b-button>
            </b-col>
          </b-row>
          <b-modal
          id="admin-user-reg-modal"
          class="user-modal create-modal"
          size="lg"
          title="관리자 추가하기"
          >
            <b-row class="modal-top-row">
              <b-col sm="6" class="my-1 top-row-banner">
                <div class="my-1 text-left">
                  <label>Member ID</label>
                  <b-form-input
                    v-model="infoModal.idMembers"
                    disabled
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="6" class="my-1 top-row-banner">
                <div class="my-1 text-left">
                <label>권한</label>
                <b-form-select size="sm" class="item-select" v-model="infoModal.menuAuth" :options="infoModal.authOptions"></b-form-select>
              </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="6" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>관리자ID</label>
                  <b-form-input
                    v-model="infoModal.idManager"
                    oninput="javascript: this.value = this.value.replace(/[^A-Za-z0-9]/ig, '')"
                    placeholder="4~7자리 입력(한글&공백&특수문자 제외)"
                    minlength="4"
                    maxlength="7"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="6" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>Password</label>
                  <b-form-input
                    v-model="infoModal.pwManager"
                    placeholder="비밀번호는 8~15 자리 사이입니다."
                    minlength="8"
                    maxlength="15"
                    type="password"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="4" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>이름</label>
                  <b-form-input
                    v-model="infoModal.nmManager"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="4" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>전화번호</label>
                  <b-form-input
                    v-model="infoModal.telManager"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="4" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>사용여부</label>
                  <b-form-select size="sm" class="item-select" v-model="infoModal.useManager" :options="infoModal.useOptions"></b-form-select>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="12" class="my-1 modal-third-area">
                <div class="my-1 text-left desc search">
                  <div class="text-right save-btn-area">
                    <b-button
                    variant="primary"
                    class="default-btn address-search btn-primary"
                    @click="modalAdd()"
                  >
                    저장
                  </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
            <template #modal-footer>
              <b-row class="modify-footer">
              </b-row>
            </template>
          </b-modal>
          <b-modal
            id="admin-user-modyfiy-modal"
            size="lg"
            class="user-modal modify-modal"
            title="관리자 수정하기"
            ok-only
            >
              <b-row class="modal-top-row">
              <b-col sm="6" class="my-1 top-row-banner">
                <div class="my-1 text-left">
                  <label>Member ID</label>
                  <b-form-input
                    v-model="infoModal.idMembers"
                    disabled
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="6" class="my-1 top-row-banner">
                <div class="my-1 text-left">
                <label>권한</label>
                <b-form-select size="sm" class="item-select" v-model="infoModal.menuAuth" :options="infoModal.authOptions"></b-form-select>
              </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="6" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>관리자ID</label>
                  <b-form-input
                    v-model="infoModal.idManager"
                    oninput="javascript: this.value = this.value.replace(/[^A-Za-z0-9]/ig, '')"
                    placeholder="4~7자리 입력(한글&공백&특수문자 제외)"
                    minlength="4"
                    maxlength="7"
                    disabled
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="6" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>Password</label>
                  <b-form-input
                    v-model="infoModal.pwManager"
                    placeholder="비밀번호는 8~15 자리 사이입니다."
                    minlength="8"
                    maxlength="15"
                    type="password"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="4" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>이름</label>
                  <b-form-input
                    v-model="infoModal.nmManager"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="4" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>전화번호</label>
                  <b-form-input
                    v-model="infoModal.telManager"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="4" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>사용여부</label>
                  <b-form-select size="sm" class="item-select" v-model="infoModal.useManager" :options="infoModal.useOptions"></b-form-select>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="12" class="my-1 modal-third-area">
                <div class="my-1 text-left desc search">
                  <div class="text-right save-btn-area">
                    <b-button
                      variant="primary"
                      class="default-btn address-search btn-primary"
                      @click="modifySave()"
                    >
                    저장
                  </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
            <template #modal-footer>
              <b-row class="modify-footer">
              </b-row>
            </template>
          </b-modal>
        </b-container>
      </div>
    </section>
  </div>
</template>
<script>
import AdminHeader from '@/components/AdminHeader'
import AdminSide from '@/components/AdminSide'
// https://bootstrap-vue.org/docs/components/table
import { mapGetters } from 'vuex'
export default {
  name: 'AdminUser',
  components: {
    'admin-header': AdminHeader,
    'admin-side': AdminSide
  },
  data () {
    return {
      typeSelected: '',
      itemOptions: [
        { value: '', text: '전체' },
        { value: 'SUPER_ADMIN', text: '어반관리자' },
        { value: 'ADMIN', text: '일반관리자' }
      ],
      repeatPassword: '',
      searchText: '',
      fields: [
        { key: 'idMembers', label: 'MemberID', class: 'text-center' },
        { key: 'idManager', label: '관리자ID', class: 'text-center', sortDirection: 'desc' },
        { key: 'menuAuth', label: '권한', class: 'text-center', sortDirection: 'desc' },
        { key: 'nmManager', label: '이름', class: 'text-center', sortDirection: 'desc' },
        { key: 'telManager', label: '전화번호', class: 'text-center', sortDirection: 'desc' },
        { key: 'useManager', label: '사용여부', class: 'text-center', sortDirection: 'desc' },
        { key: 'actions', label: '', class: 'text-center' }
      ],
      infoModal: {
        idMembers: '',
        pwManager: '',
        idManager: '',
        menuAuth: '',
        nmManager: '',
        telManager: '',
        useManager: '',
        useOptions: [
          { value: 'Y', text: '사용' },
          { value: 'N', text: '미사용' }
        ],
        authOptions: [
          { value: 'SUPER_ADMIN', text: '어반관리자' },
          { value: 'ADMIN', text: '일반관리자' }
        ]
      }
    }
  },
  created () {
    this.initAdminUser()
  },
  watch: {
  },
  methods: {
    initAdminUser () {
      this.$store.dispatch('apiAdminUserList', {'searchKey': this.searchText, 'authType': this.typeSelected})
    },
    getParamData (obj, flag) {
      const params = {
        'flag': flag,
        'idMembers': obj.idMembers === '신규' ? '' : obj.itemId,
        'pwManager': obj.pwManager,
        'idManager': obj.idManager,
        'menuAuth': obj.menuAuth,
        'nmManager': obj.nmManager,
        'telManager': obj.telManager,
        'useManager': obj.useManager
      }
      return params
    },
    deleteItem (item, index) {
      const deleteConfirm = confirm('정말 삭제하시겠습니까??')
      if (deleteConfirm === true) {
        this.$store.dispatch('apiAdminUserTran', this.getParamData(item, 'D')).then(() => {
          // console.log('this.tranRtnStr = ' + this.tranRtnStr)
          if (this.tranRtnStr.result === 'success') {
            alert('삭제 되었습니다.')
            this.initAdminUser()
          } else {
            alert('삭제에 실패하였습니다.')
          }
        })
        // this.items.splice(index, 1)
      } else {
        return false
      }
    },
    modalAdd () {
      if (this.vaildId() === false) {
        alert('ID는 최소 4~7 글자 입니다.')
        return
      }
      var pwValid = this.vaildPw()
      if (pwValid === 'lengthError') {
        alert('비밀번호는 최소 8~15 글자 입니다.')
        return
      } else if (pwValid === 'wordError') {
        alert('비밀번호는 1개 이상의 특수문자가 포함되어야 합니다.')
        return
      } else if (pwValid === 'blankError') {
        alert('비밀번호에 공백이 존재합니다.')
        return
      }
      this.$store.dispatch('apiAdminUserTran', this.getParamData(this.infoModal, 'I')).then(() => {
        // console.log('this.tranRtnStr = ' + this.tranRtnStr)
        if (this.tranRtnStr.result === 'success') {
          this.$nextTick(() => {
            alert('등록이 완료 되었습니다.')
            this.initAdminUser()
            this.$bvModal.hide('admin-user-reg-modal')
          })
        } else if (this.tranRtnStr.result === 'duplicateError') {
          alert('중복 된 ID 입니다. 다시 입력해주세요.')
        } else {
          alert('수정 된 내용 저장에 실패하였습니다.')
        }
      })
    },
    modifySave () {
      var pwValid = this.vaildPw()
      if (pwValid === 'lengthError') {
        alert('비밀번호는 최소 8~15 글자 입니다.')
        return
      } else if (pwValid === 'wordError') {
        alert('비밀번호는 1개 이상의 특수문자가 포함되어야 합니다.')
        return
      } else if (pwValid === 'blankError') {
        alert('비밀번호에 공백이 존재합니다.')
        return
      }
      this.$store.dispatch('apiAdminUserTran', this.getParamData(this.infoModal, 'U')).then(() => {
        // console.log('this.tranRtnStr = ' + this.tranRtnStr.result)
        if (this.tranRtnStr.result === 'success') {
          this.$nextTick(() => {
            alert('저장이 완료 되었습니다.')
            this.initAdminUser()
            this.$bvModal.hide('admin-user-modyfiy-modal')
          })
        } else {
          alert('수정 된 내용 저장에 실패하였습니다.')
        }
      })
    },
    itemFilter () {
      this.initAdminUser()
    },
    vaildId () {
      if ((this.infoModal.idManager.length > 3) && (this.infoModal.idManager.length < 8)) {
        return true
      } else {
        return false
      }
    },
    vaildPw () {
      // 비밀번호는 최소 8글자 이상 그리고 하나 이상의 특수문자를 포함해야합니다.
      var spe = this.infoModal.pwManager.search(/[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/gi)
      if (this.infoModal.pwManager.length < 8 || this.infoModal.pwManager.length > 15) {
        return 'lengthError'
      } else if (spe < 0) {
        return 'wordError'
      } else if (this.infoModal.pwManager.search(/\s/) !== -1) {
        return 'blankError'
      } else {
        return 'ok'
      }
    },
    modifyItem (item, index) {
      this.infoModal.idMembers = item.idMembers
      this.infoModal.pwManager = item.pwManager
      this.infoModal.idManager = item.idManager
      this.infoModal.menuAuth = item.menuAuth
      this.infoModal.nmManager = item.nmManager
      this.infoModal.telManager = item.telManager
      this.infoModal.useManager = item.useManager
      this.$root.$emit('bv::show::modal', 'admin-user-modyfiy-modal')
    },
    newModal () {
      this.infoModal.idMembers = '신규'
      this.infoModal.pwManager = ''
      this.infoModal.idManager = ''
      this.infoModal.menuAuth = 'SUPER_ADMIN'
      this.infoModal.nmManager = ''
      this.infoModal.telManager = ''
      this.infoModal.useManager = 'Y'
      this.$root.$emit('bv::show::modal', 'admin-user-reg-modal')
      // this.$root.$emit('bv::show::modal', 'doc-item-modyfiy-modal')
    }
  },
  computed: {
    ...mapGetters({
      items: 'getAdminUser',
      tranRtnStr: 'getAdminUserRtn'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/admin/AdminUser.vue